import * as React from 'react';
import FiltersBar from '../FiltersBar';
import LoadMore from '../LoadMore';
import NoResults from '../NoResults';
import { FiltersProvider } from '../../contexts/filters';
import { PostsProvider } from '../../contexts/posts';
import PostsGrid from '../PostsGrid';
import Posts from '../Posts';
import Pagination from '../PaginationNumbers';
import { useSettingsContext } from '../../contexts/settings';
import SmallCardFilters from '../SmallCardFilters';

const SageCollabCenterLayout = () => {
	const settings = useSettingsContext();

	return (
		<>
			<FiltersProvider>
				<FiltersBar>
					<SmallCardFilters />
				</FiltersBar>
				<PostsProvider>
					<Posts>
						<PostsGrid posts={[]} />
						{settings.paginationType === 'load_more' ? (
							<LoadMore page={0} maxNumPages={0} />
						) : (
							<Pagination page={0} maxNumPages={0} />
						)}
						<NoResults posts={[]} />
					</Posts>
				</PostsProvider>
			</FiltersProvider>
		</>
	);
};

SageCollabCenterLayout.displayName = 'SageCollabCenterLayout';

export default SageCollabCenterLayout;
